// extracted by mini-css-extract-plugin
export default {"barisfavorit":"ListFavorit_barisfavorit__oli66","judulbukufavorit":"ListFavorit_judulbukufavorit__oxoiG"};